import type { ValidCurrency } from '../config';

import { FormattedNumber } from './FormattedNumber';

type Props = {
  currency: ValidCurrency;
  options?: Intl.NumberFormatOptions;
  value?: number;
};

export function FormattedPrice({ options, value, currency }: Props): React.ReactNode {
  return (
    <FormattedNumber value={value ?? 0} options={{ style: 'currency', currency, ...options }} />
  );
}
